import { newProjectActions } from 'features/BillOfMaterials/store/projectReducer'
import { QF_Events, QF_EventsArgs } from 'model/QF_Events'
import {
  PdfFeature,
  PdfPage,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import store from 'store/configureStore'
import { ProjectState } from 'store/Project/ProjectTypes'

let clickTimeout = null

const clearClickTimeout = () => {
  if (clickTimeout) {
    clearTimeout(clickTimeout)
    clickTimeout = null
  }
}
export const handleSvgHighlightClicked = async (
  featureId: string,
  pdfPage: PdfPage,
  pdfFeature: PdfFeature,
) => {
  try {
    clearClickTimeout()

    clickTimeout = setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent<QF_EventsArgs['PDFHighlightClicked']>(
          QF_Events.PDFHighlightClicked,
          {
            detail: {
              featureId: featureId,
              pdfPage: pdfPage,
              pdfFeature: pdfFeature,
            },
          },
        ),
      )

      store.dispatch(
        newProjectActions.setProjectStateProperties({
          currentCheckList: {
            activeFeatureId: featureId,
            shallScrollToActiveItem: true,
          },
        } as Partial<ProjectState>),
      )
    }, 250)
  } catch (err) {
    console.error('error', err)
  }
}

export const handleSvgHighlightDoubleClicked = (pdfFeature: PdfFeature) => {
  clearClickTimeout()

  document.dispatchEvent(
    new CustomEvent<QF_EventsArgs['PDFHighlightDoubleClicked']>(
      QF_Events.PDFHighlightDoubleClicked,
      {
        detail: {
          pdfFeature: pdfFeature,
        },
      },
    ),
  )
}
